// Enhanced lazy loading for better image performance
class ImageOptimizer {
  constructor() {
    this.init();
  }

  init() {
    // Set up intersection observer for lazy loading
    this.setupLazyLoading();
    
    // Preload critical images
    this.preloadCriticalImages();
    
    // Add loading event listeners
    this.setupLoadingListeners();
  }

  setupLazyLoading() {
    if ('IntersectionObserver' in window) {
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            this.loadImage(img);
            observer.unobserve(img);
          }
        });
      }, {
        rootMargin: '50px 0px',
        threshold: 0.01
      });

      // Observe all lazy images
      document.querySelectorAll('img[loading="lazy"]').forEach(img => {
        imageObserver.observe(img);
      });
    }
  }

  loadImage(img) {
    if (img.dataset.src) {
      img.src = img.dataset.src;
    }
    
    img.addEventListener('load', () => {
      img.classList.add('loaded');
    });
  }

  preloadCriticalImages() {
    // Preload the first product image for better LCP
    const firstProductImage = document.querySelector('.product__media-item:first-child img');
    if (firstProductImage) {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = firstProductImage.src || firstProductImage.dataset.src;
      document.head.appendChild(link);
    }
  }

  setupLoadingListeners() {
    // Add fade-in effect for loaded images
    document.addEventListener('load', (e) => {
      if (e.target.tagName === 'IMG') {
        e.target.classList.add('loaded');
      }
    }, true);
  }

  // Method to update image sizes based on viewport
  updateImageSizes() {
    const images = document.querySelectorAll('img[data-responsive]');
    images.forEach(img => {
      const sizes = this.calculateOptimalSizes(img);
      img.sizes = sizes;
    });
  }

  calculateOptimalSizes(img) {
    const container = img.closest('.product__media-container');
    if (!container) return img.sizes;

    const containerWidth = container.offsetWidth;
    const devicePixelRatio = window.devicePixelRatio || 1;
    const optimalWidth = Math.ceil(containerWidth * devicePixelRatio);

    // Return appropriate sizes string
    if (window.innerWidth >= 990) {
      return `${optimalWidth}px`;
    } else if (window.innerWidth >= 750) {
      return `calc(100vw - 3rem)`;
    } else {
      return `100vw`;
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ImageOptimizer();
  });
} else {
  new ImageOptimizer();
}

// Update sizes on resize (debounced)
let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    if (window.imageOptimizer) {
      window.imageOptimizer.updateImageSizes();
    }
  }, 250);
});

// Export for global access
window.ImageOptimizer = ImageOptimizer;